export { default as ExclamationTriangleIcon } from './ExclamationTriangleIcon';
